import { Button, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { RiAddFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { openCreateVideos } from "../../../modules/admin-modules/models/Actions";
import { createVideoVouchersRequest } from "../../../modules/admin-modules/videos/Actions";

const SearchBar = ({ setAdd, setSelectedData }) => {
  const dispatch = useDispatch();
  const count = useSelector((state) => state.videos.count);

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "white",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  return (
    <VStack w="100%" my="30px">
      <Flex alignItems="center" w="100%" justifyContent="space-between">
        <Text fontSize="24px" fontWeight="600" color="main_1">
          الفيديوهات
        </Text>

        <Flex alignItems="center">
          <Button
            borderRadius="16px"
            leftIcon={<RiAddFill />}
            mx="8px"
            color="white"
            bg="main_1"
            _focus={{ outline: "none" }}
            onClick={() => {
              setAdd(true);
              dispatch(openCreateVideos());
            }}
          >
            إضافة فيديو
          </Button>

          <Button
            borderRadius="16px"
            mx="8px"
            color="white"
            bg="main_1"
            _focus={{ outline: "none" }}
            onClick={() => {
              dispatch(createVideoVouchersRequest());
            }}
          >
            create video vouchers
          </Button>

          <LogoutMenu />
        </Flex>
      </Flex>
      <Text w="100%" fontSize="20px" textAlign="right">
        {" "}
        عدد الفيديوهات: {count}
      </Text>

      <HStack
        w="100%"
        justifyContent="space-between"
        bg="#f5f5f5"
        mt="40px !important"
        p="10px"
        mb="-30px !important"
      >
        <HStack spacing="5px">
          {/* <Select
            options={options}
            onChange={(data) => {}}
            styles={colourStyles}
            placeholder="الصف"
          />
          <Select
            options={options}
            onChange={(data) => {}}
            styles={colourStyles}
            placeholder="الفصل"
          /> */}

          {/* <InputGroup w="400px">
            <InputLeftElement
              pointerEvents="none"
              children={<RiSearch2Fill color="main_1" fontSize="20px" />}
            />
            <Input
              type="text"
              placeholder="عنوان فيديو"
              borderRadius="16px"
              bg="white"
            />
          </InputGroup> */}
        </HStack>

        <HStack spacing="5px">
          {/* <Select
            options={options}
            onChange={(data) => {}}
            styles={colourStyles}
            placeholder="التصنيف"
          />

          <Select
            options={options}
            onChange={(data) => {}}
            styles={colourStyles}
            placeholder="الأحدث"
          /> */}
        </HStack>
      </HStack>
    </VStack>
  );
};

export default SearchBar;
